export const GET_ASSET_LEVEL = 'GET_ASSET_LEVEL';
export const SET_ASSET_LEVEL_PAGINATION = 'SET_ASSET_LEVEL_PAGINATION';
export const SET_ASSET_LEVEL_FILTERS = 'SET_ASSET_LEVEL_FILTERS';
export const RESET_ASSET_LEVEL = 'RESET_ASSET_LEVEL';
export const TOGGLE_ASSET_LEVEL = 'TOGGLE_ASSET_LEVEL';
export const ADD_ASSET_LEVEL = 'ADD_ASSET_LEVEL';
export const UPDATE_ASSET_LEVEL = 'UPDATE_ASSET_LEVEL';
export const GET_ASSET_LEVEL_BY_ID = 'GET_ASSET_LEVEL_BY_ID';
export const RESET_ASSET_LEVEL_FORM = 'RESET_ASSET_LEVEL_FORM';
export const MODIFY_EDITING_ASSET_LEVEL = 'MODIFY_EDITING_ASSET_LEVEL';

//Groups
export const MODIFY_CUSTOM_FIELD_EDITING_ASSET_LEVEL = 'MODIFY_CUSTOM_FIELD_EDITING_ASSET_LEVEL';



// WEBPACK FOOTER //
// src/modules/secured/modules/asset_level/constants/asset_level_constants.js